// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3-JZC","label":"LabeledBox_label__3HGXV"};